


























import { Component, Prop, Vue } from 'vue-property-decorator';
import { SystemLinkType } from '@/data/projects';

const typeMapper: { [key: string]: string } = {
  github: 'GitHub',
  tryit: 'Try it!',
  none: 'None',
};

@Component
export default class SystemLink extends Vue {
  @Prop() private type!: SystemLinkType;
  @Prop() private link!: string;

  get absoluteLink(): string {
    if (this.type === 'github') {
      return `https://www.github.com/gcali/${this.link}`;
    } else {
      return this.link;
    }
  }

  get displayName(): string {
    return typeMapper[this.type];
  }
}
